import { Travelers, TravelerType } from './types'

export const countTotalNumberOfTravelers = (travelers: Travelers | undefined) => {
  if (travelers == null) {
    return 0
  }

  return Object.values(TravelerType)
    .map((travelerType) => travelers[travelerType])
    .filter((travelerData) => Boolean(travelerData?.isVisible !== false))
    .reduce((sum, travelerData) => sum + (travelerData?.quantity ?? 0), 0)
}
